import { useEffect, useState } from 'react';

export const CalendarMonthProperties = (
  today: Date,
  currentMonth: number,
  currentYear: number
) => {
  const [daysInMonth, setDaysInMonth] = useState<number[]>([]);
  const [startingBlankDays, setStartingBlankDays] = useState<number[]>([]);
  const [endingBlankDays, setEndingBlankDays] = useState<number[]>([]);

  const eventColor = (color: string): string => {
    switch (color) {
      case 'sky':
        return 'text-white bg-sky-500';
      case 'indigo':
        return 'text-white bg-indigo-500';
      case 'yellow':
        return 'text-white bg-amber-500';
      case 'emerald':
        return 'text-white bg-emerald-500';
      case 'red':
        return 'text-white bg-rose-400';
      default:
        return '';
    }
  };

  const isToday = (date: number): boolean => {
    const day = new Date(currentYear, currentMonth, date);
    return today.toDateString() === day.toDateString();
  };

  useEffect(() => {
    const days = new Date(currentYear, currentMonth + 1, 0).getDate();

    // starting empty cells (previous month)
    const startingDayOfWeek: number = new Date(
      currentYear,
      currentMonth
    ).getDay();
    let startingBlankDaysArray: number[] = [];
    for (let i = 1; i <= startingDayOfWeek; i++) {
      startingBlankDaysArray.push(i);
    }

    // ending empty cells (next month)
    const endingDayOfWeek: number = new Date(
      currentYear,
      currentMonth + 1,
      0
    ).getDay();
    let endingBlankDaysArray: number[] = [];
    for (let i = 1; i < 7 - endingDayOfWeek; i++) {
      endingBlankDaysArray.push(i);
    }

    // current month cells
    let daysArray: number[] = [];
    for (let i = 1; i <= days; i++) {
      daysArray.push(i);
    }

    setStartingBlankDays(startingBlankDaysArray);
    setEndingBlankDays(endingBlankDaysArray);
    setDaysInMonth(daysArray);
  }, [currentMonth, currentYear]);

  return {
    today,
    currentMonth,
    currentYear,
    daysInMonth,
    setDaysInMonth,
    startingBlankDays,
    setStartingBlankDays,
    endingBlankDays,
    setEndingBlankDays,
    eventColor,
    isToday,
  };
};

export const CalendarWeekProperties = (today: Date, startOfWeek: Date) => {
  const [daysInWeek, setDaysInWeek] = useState<Date[]>([]);

  const eventColor = (color: string): string => {
    switch (color) {
      case 'sky':
        return 'text-white bg-sky-500';
      case 'indigo':
        return 'text-white bg-indigo-500';
      case 'yellow':
        return 'text-white bg-amber-500';
      case 'emerald':
        return 'text-white bg-emerald-500';
      case 'red':
        return 'text-white bg-rose-400';
      default:
        return '';
    }
  };

  const isToday = (date: Date): boolean => {
    return today.toDateString() === date.toDateString();
  };

  useEffect(() => {
    let daysArray: Date[] = [];
    for (let i = 0; i < 7; i++) {
      const day = new Date(
        startOfWeek.getFullYear(),
        startOfWeek.getMonth(),
        startOfWeek.getDate() + i
      );
      daysArray.push(day);
    }

    setDaysInWeek(daysArray);
  }, [startOfWeek]);

  return {
    daysInWeek,
    setDaysInWeek,
    eventColor,
    isToday,
  };
};
